/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import * as React from 'react'
import classNames from 'classnames/bind'
import Icon from 'elements/Icon'
import * as styles from './CollapsibleBlock.scss'

interface IProps{
  isOpen?: boolean,
  title: string,
  onCheck?: () => void,
  checkboxTitle?: string,
  styleType: string,
  isChecked: boolean,
  onOpen: () => void,
  onClose: () => void,
  disabled: boolean,
  setRef: () => void,
  isCheckboxReverseMode: boolean,
}

const cx = classNames.bind(styles)

interface IState {
  isOpen: boolean,
  isChecked: boolean,
}

class CollapsibleBlock extends React.Component<IProps, IState> {
  public readonly state = {
    isOpen: this.props.isOpen || false,
    isChecked: this.props.isChecked,
  }

  public componentWillReceiveProps (nextProps) {
    if (this.props.isOpen !== nextProps.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen,
      })
    }
  }

  private onToggle = () => {
    if (this.props.onCheck && this.state.isChecked && !this.props.isCheckboxReverseMode) {
      return
    }
    if (this.props.onCheck && !this.state.isChecked && this.props.isCheckboxReverseMode) {
      return
    }

    if (!this.state.isOpen) {
      this.props.onOpen && this.props.onOpen()
    } else {
      this.props.onClose && this.props.onClose()
    }

    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  private onChangeCheckbox = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    })

    if (!this.state.isOpen && (
      (this.state.isChecked && !this.props.isCheckboxReverseMode)
      || (!this.state.isChecked && this.props.isCheckboxReverseMode)
    )) {
      this.setState({
        isOpen: true,
      })
    } else if (this.state.isOpen
      || (!this.state.isOpen && !this.state.isChecked && !this.props.isCheckboxReverseMode)
      || (!this.state.isOpen && this.state.isChecked && this.props.isCheckboxReverseMode)) {
      this.setState({
        isOpen: false,
      })
    }
    this.props.onCheck()
  }

  private onPreventDoubleClick = e => {
    if (e.detail > 1) {
      e.preventDefault()
    }
  }

  public componentDidMount () {
    window.addEventListener('mousedown', this.onPreventDoubleClick)
  }

  public componentWillUnmount () {
    window.removeEventListener('mousedown', this.onPreventDoubleClick)
  }

  public render () {
    const { title, children, onCheck, checkboxTitle, styleType, isChecked, disabled, setRef } = this.props
    const { isOpen } = this.state

    return (
      <div ref={setRef} className={cx('root', styleType, { show: isOpen })}>
        <header
          className={cx(
          'header',
            {
              disabled,
            },
          )}
        >
          <div
            className={cx(
              'headerButton',
              {
                disabled,
                withCheckBox: !!onCheck,
              },
            )}
            onClick={this.onToggle}
            role='button'
          >
            <div className={styles.headerTitle}>{title}</div>
            {onCheck && (
              <div className={styles.headerCheckbox}>
                <input checked={isChecked} onChange={this.onChangeCheckbox} type='checkbox'/>
                <label>{checkboxTitle}</label>
              </div>
            )}
          </div>
          {((!this.state.isChecked && !this.props.isCheckboxReverseMode)
            || (this.state.isChecked && this.props.isCheckboxReverseMode)) && (
            <div className={styles.icon}>
              <Icon name='chevronDown'/>
            </div>
          )}
        </header>
        <div className={cx(styles.collapse, { isOpen: styles.show })}>
          {children}
        </div>
      </div>
    )
  }
}

export default CollapsibleBlock
